<div class="p-modal-login">
  <div class="p-modal-login__title">
    <h2 class="c-text-l" [innerHTML]="'label.login' | staticMsg"></h2>
  </div>
  <div *ngIf="isNotLogin()">
    <p class="p-modal-login__text" [innerHTML]="'label.membershipStatus' | staticMsg"></p>
  </div>
  <div *ngIf="isNotLogin()" class="p-modal-login__item">
    <asw-input
      id="loginAnaMemberInput"
      [label]="'label.amcAccountNumber' | staticMsg"
      autocomplete="username"
      aria-invalid="false"
      [placeholder]="'placeholder.amcNumber' | staticMsg"
      [formControl]="idNameFormContrl"
      [alt]="'reader.amcAccountNumber' | staticMsg"
    ></asw-input>
    <div class="p-modal-login__item-link" [innerHTML]="'message.forgetAccountNumber' | staticMsg"></div>
  </div>

  <div class="p-modal-login__item">
    <asw-input
      id="loginPasswordInput"
      [label]="'label.password' | staticMsg"
      type="password"
      autocomplete="current-password"
      aria-invalid="false"
      [placeholder]="'placeholder.password' | staticMsg"
      [formControl]="passwordFormContrl"
      [alt]="'reader.password' | staticMsg"
    ></asw-input>
    <div class="p-modal-login__item-link" [innerHTML]="'message.forgetPassword' | staticMsg"></div>
  </div>
  <div class="p-modal-login__btn">
    <div class="p-modal-login__btn-list">
      <asw-button
        class="p-modal-login__btn-list"
        type="primary"
        id="login-component-button-login"
        [label]="'label.continueWithLogin' | staticMsg"
        (click$)="clickLogin($event)"
        throttleClick
      ></asw-button>

      <div *ngIf="isSkipEnable && isNotLogin()">
        <asw-button
          class="p-modal-login__btn-list"
          type="secondary"
          id="login-component-button-login"
          [label]="'label.continueWithoutLogin' | staticMsg"
          (click$)="clickContinue($event)"
          throttleClick
        ></asw-button>
      </div>
    </div>
  </div>
  <div class="p-modal-login__join">
    <div class="p-modal-login__join-link" [innerHTML]="'label.AmcMileageClubAdmission' | staticMsg"></div>
  </div>
</div>
